
<div class="stepper flex flex-nowrap overflow-x-hidden w-100">
  <ng-container *ngFor="let step of steps; let cnt = count; let i = index;">
    <div class="step min-w-full" *ngIf="_stepindex === i">
      <ng-container *ngTemplateOutlet="step.template"></ng-container>
    </div>
  </ng-container>
</div>
